import styled from 'styled-components'

export const ContentMaintenance = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  height: 100%;
  text-align: center;
`
